import { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);

    useEffect(() => {
        const t = localStorage.getItem('fwb_token');
        const u = localStorage.getItem('fwb_user');
        if (t && u) {
            setToken(t);
            setUser(JSON.parse(u));
        }
    }, []);

    const login = (u, t) => {
        localStorage.setItem('fwb_token', t);
        localStorage.setItem('fwb_user', JSON.stringify(u));
        setUser(u);
        setToken(t);
    };

    const logout = () => {
        localStorage.removeItem('fwb_token');
        localStorage.removeItem('fwb_user');
        setUser(null);
        setToken(null);
    };

    return <AuthContext.Provider value={{ user, token, login, logout }}>{children}</AuthContext.Provider>;
}

export default function useAuth() {
    return useContext(AuthContext);
}
